require('@npm/luminous-lightbox/dist/Luminous.js')
require('@npm/luminous-lightbox/dist/luminous-basic.css')
import $ from 'jquery'

export default function () {
    let gals = $('a.lightbox-gal').toArray().reduce((carry, x) => {
        let gal = x.getAttribute('data-gallery')
        if (!gal) gal = 'default'
        if (!(gal in carry)) carry[gal] = []
        carry[gal].push(x)
        return carry
    }, {})
    for (let key in gals) {
        new LuminousGallery(gals[key]);
    }
    // new Luminous(document.querySelector('a.lightbox'));
    // new LuminousGallery(document.querySelectorAll('a.lightbox-gal'));
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/lightbox.jsx